import React, { memo, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import config from '../../config';
import { isResearcher } from '../../utils/checkPermissions';
import { showError } from '../../utils/MessagePopup';
import connectOptions, { mergeProps } from '../../utils/connectOptions';
import { usePopupContext } from '../../contexts/PopupContext';

const CompanyBuyerCreateContainer = props => {
  const { hasPopup, openPopup, closePopup } = usePopupContext();

  const hasAccess = useCallback(() => {
    if (!props.user) return false;

    return !isResearcher(props.user.getIn(['roles', 0, 'slug'], null));
  }, [props.user]);

  useEffect(() => {
    if (!props.user) return;

    if (!hasAccess()) {
      showError(openPopup, config.permisionError, () => {
        props.history.push('/');
        closePopup();
      });

      return;
    }

    if (hasPopup()) return;

    openPopup('AddBuyerCompanyPopup');
  });

  return <Helmet title="Create Buyer Company" />;
};

export { CompanyBuyerCreateContainer };

const mapStateToProps = state => ({
  user: state.auth.get('user', null),
});

export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(CompanyBuyerCreateContainer));
